import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  extractWizProperty,
  getWizSeverityClass,
} from '@/sections/poe/processors/wiz/helpers';
import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';
import { cn } from '@/utils/classname';

export function renderSecretInstance(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { wizData } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (
    wizData &&
    wizData['secret instance'] &&
    mainTabKeys.includes('DETECTION')
  ) {
    const secretInstance = wizData['secret instance'];
    sections['wiz_secret_instance'] = (
      <div className="space-y-4">
        <div className="border-warning border-l-4 p-4">
          <div className="flex items-center">
            <InformationCircleIcon className="text-warning mr-2 size-5" />
            <h4 className="text-chariot-text-primary font-semibold">
              Secret Instance Detection
            </h4>
          </div>
        </div>
        <div className="border-chariot-stroke rounded-lg border p-4">
          <h5 className="text-chariot-text-primary mb-3 font-medium">
            Detection Details
          </h5>
          <div className="space-y-3 text-sm">
            {extractWizProperty(secretInstance, 'path') && (
              <div className="flex items-start gap-3">
                <span className="text-chariot-text-secondary min-w-16 font-medium">
                  Location:
                </span>
                <span className="bg-chariot-background-secondary rounded px-2 py-1 font-mono">
                  {extractWizProperty(secretInstance, 'path')}
                </span>
              </div>
            )}
            {extractWizProperty(secretInstance, 'confidence') && (
              <div className="flex items-start gap-3">
                <span className="text-chariot-text-secondary min-w-16 font-medium">
                  Confidence:
                </span>
                <span
                  className={cn(
                    'font-medium',
                    extractWizProperty(secretInstance, 'confidence') ===
                      'ConfidenceHigh'
                      ? 'text-error'
                      : 'text-warning'
                  )}
                >
                  {extractWizProperty(secretInstance, 'confidence')?.replace(
                    'Confidence',
                    ''
                  )}
                </span>
              </div>
            )}
            {extractWizProperty(secretInstance, 'secretRuleId') && (
              <div className="flex items-start gap-3">
                <span className="text-chariot-text-secondary min-w-16 font-medium">
                  Rule ID:
                </span>
                <code className="text-xs">
                  {extractWizProperty(secretInstance, 'secretRuleId')}
                </code>
              </div>
            )}
            {extractWizProperty(secretInstance, 'severity') && (
              <div className="flex items-start gap-3">
                <span className="text-chariot-text-secondary min-w-16 font-medium">
                  Severity:
                </span>
                <span
                  className={getWizSeverityClass(
                    extractWizProperty(secretInstance, 'severity')
                  )}
                >
                  {extractWizProperty(secretInstance, 'severity')?.replace(
                    'Severity',
                    ''
                  )}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
    tempTabs['DETECTION'].push({
      label: 'Secret Instance',
      value: 'wiz_secret_instance',
    });
  }
}
